import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Check } from 'lucide-react';

interface ServiceCardProps {
  title: string;
  description: string;
  price: string;
  features: string[];
  popular?: boolean;
  isFree?: boolean;
  onSelect: () => void;
  className?: string;
  isSelected?: boolean;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  price,
  features,
  popular = false,
  isFree = false,
  onSelect,
  className = '',
  isSelected = false
}) => {
  return (
    <Card className={`relative h-full flex flex-col transition-all duration-300 ${
      isSelected ? 'ring-2 ring-primary ring-offset-2 bg-primary/5' : 'hover:shadow-lg'
    } ${className}`}>
      {popular && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-primary text-white px-4 py-1 rounded-full text-sm font-medium whitespace-nowrap">
            Most Popular
          </span>
        </div>
      )}
      
      {isFree && (
        <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
          <span className="bg-green-500 text-white px-4 py-1 rounded-full text-sm font-medium whitespace-nowrap">
            Free Consultation
          </span>
        </div>
      )}
      
      <CardHeader>
        <CardTitle className="text-xl">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
        <div className={`text-3xl font-bold ${isFree ? 'text-green-600' : 'text-primary'}`}>
          {price}
          <span className="text-sm font-normal text-muted-foreground ml-1">per application</span>
        </div>
      </CardHeader>
      
      <CardContent className="flex-1">
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center space-x-2 animate-fade-in" style={{ animationDelay: `${index * 100}ms` }}>
              <Check className="h-4 w-4 text-green-500 flex-shrink-0" />
              <span className="text-sm">{feature}</span>
            </li>
          ))}
        </ul>
      </CardContent>
      
      <CardFooter className="mt-auto pt-6">
        <Button 
          className={`w-full transition-all duration-200 ${
            isSelected ? 'bg-primary text-white hover:bg-primary/90' : ''
          }`}
          variant={isSelected ? "primary" : popular ? "primary" : "outline"}
          onClick={onSelect}
        >
          {isFree ? 'Get Free Consultation' : isSelected ? 'Selected Plan' : 'Choose Plan'}
        </Button>
      </CardFooter>
    </Card>
  );
};

export default ServiceCard;
